import { FC } from 'react';

import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import { useFormat, ValuationHooks } from '../../../../hooks/index';
import { eventFormType, EventTypeBackend } from '../../../../types/events.types';
import { toNumber } from '../../../../utils/to-number.util';
import { CardProps } from './transaction-card-variants.types';
import { TransactionOverviewItem } from './transaction-overview-item';
import { TransactionTitleItem } from './transaction-title-item';

export const Payout: FC<CardProps> = ({ event }) => {
  const { format } = useFormat();
  const { valuation } = ValuationHooks.useCurrent();
  if (event.type !== EventTypeBackend.PAYOUT) return <></>;

  const {
    type,
    exercise: { items },
    createdAt,
  } = event;

  return (
    <>
      {items.map(({ id, vestingTask, exercised, payout }) => (
        <div className="flex flex-col divide-y divide-gray-100 rounded-md shadow-sm" key={id}>
          <TransactionTitleItem
            createdAt={format(createdAt, 'dd/MM/yyyy')}
            name={<AppFormattedMessage id={eventFormType[type]} />}
          />
          <TransactionOverviewItem
            title={<AppFormattedMessage id="TRANSACTION_TYPE" />}
            value={<AppFormattedMessage id={eventFormType[type]} />}
          />
          <TransactionOverviewItem
            title={<AppFormattedMessage id="STAKEHOLDER" />}
            value={vestingTask.grantItem.stakeholder.fullName}
          />
          <TransactionOverviewItem
            title={<AppFormattedMessage id="SHARES_PAID_OUT" />}
            value={exercised.toLocaleString('en-US')}
          />
          <TransactionOverviewItem
            title={<AppFormattedMessage id="TOTAL_PAYOUT" />}
            value={`${(payout ? payout.toLocaleString('en-US') : exercised * toNumber(valuation?.sharePrice)).toLocaleString('en-US')}`}
          />
        </div>
      ))}
    </>
  );
};
